import MispricedStockCard from './MispricedStockCard';

export default function MispricedStockList({ stocks, type }) {
  const isOver = type === "over";
  return (
    <div>
      <div style={{ display:"flex", alignItems:"baseline", gap:8, marginBottom:12 }}>
        <span style={{ fontSize:15, fontWeight:800, color:isOver?"#FF3B30":"#00C805" }}>{isOver?"▼ 20 Most Overvalued":"▲ 20 Most Undervalued"}</span>
        <span style={{ fontSize:11, color:"rgba(255,255,255,0.62)" }}>{isOver?"Biggest downside to fair value":"Biggest upside to fair value"}</span>
      </div>
      {(stocks||[]).map((s,i) => <MispricedStockCard key={i} s={s} type={type} i={i}/>)}
    </div>
  );
}
